// extracted by mini-css-extract-plugin
export default {"section":"TabletFilterSection_section__1apy8","field":"TabletFilterSection_field__xG7fF"};